import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("pt-br");

export const SINDI_TIME_ZONE = "America/Sao_Paulo";

export const djs = dayjs;

export function currentMonth(now: Date | string = new Date()) {
	const current = djs(now).tz(SINDI_TIME_ZONE);
	const start = current.startOf("month");
	const end = current.endOf("month");

	return {
		id: start.format("YYYY-MM"),
		label: start.format("MMMM [de] YYYY"),
		start: start.format("YYYY-MM-DD"),
		end: end.format("YYYY-MM-DD"),
		requestFrom: start.subtract(1, "day").format("YYYY-MM-DD"),
	};
}

export function bankPostingDate(isoDate: string) {
	const date = isoDate.slice(0, 10);
	const calendarDate = new Date(`${date}T00:00:00Z`);
	if (
		!/^\d{4}-\d{2}-\d{2}$/u.test(date) ||
		!Number.isFinite(calendarDate.getTime()) ||
		calendarDate.toISOString().slice(0, 10) !== date
	) {
		throw new Error("Data bancária inválida");
	}
	if (isoDate === date) return date;
	if (
		!/^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d{1,9})?)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)$/u.test(
			isoDate,
		) ||
		!Number.isFinite(new Date(isoDate).getTime())
	) {
		throw new Error("Data bancária inválida");
	}
	return djs(isoDate).tz(SINDI_TIME_ZONE).format("YYYY-MM-DD");
}

export function pluggySyncWindow(now: Date = new Date()) {
	const today = djs(now).tz(SINDI_TIME_ZONE).startOf("day");
	const monthStart = today.startOf("month");
	const lookback = today.subtract(10, "day");
	const start = lookback.isBefore(monthStart) ? lookback : monthStart;
	const months = [currentMonth(start.toDate())];
	if (start.format("YYYY-MM") !== today.format("YYYY-MM")) {
		months.push(currentMonth(today.toDate()));
	}
	return {
		start: start.format("YYYY-MM-DD"),
		end: today.format("YYYY-MM-DD"),
		requestFrom: start.subtract(1, "day").format("YYYY-MM-DD"),
		requestTo: today.add(1, "day").format("YYYY-MM-DD"),
		months,
	};
}
